import P from 'prop-types';
import React, { useState, useContext, useRef } from 'react';
import { Modal } from '../Modal';
import './styles.css';
import { GlobalContext } from '../../contexts/HomeContext';
import { Capitalize } from '../../utils/utils';
import { useNavigate } from 'react-router';
import LogoWhats from '../../img/whatsapp.png';
import LogoFacebook from '../../img/facebook.png';
import LogoInstagram from '../../img/instagram.png';
import LogoTikTok from '../../img/tiktok.png';
import LogoTwitter from '../../img/twitter.png';
import LogoYoutube from '../../img/youtube.png';
import { BuscaDropdown } from '../BuscaDropdown';

export const BarTop = () => {
  const { dadosApp, user, openPedidos, setOpenPedidos } = useContext(GlobalContext);
  const [modalMenu, setModalMenu] = useState(false);
  const [modalOpcoes, setModalOpcoes] = useState(false);
  const [buscaAberta, setBuscaAberta] = useState(false);
  const topBarRef = useRef(null);
  const menuBtnRef = useRef(null);
  const navigate = useNavigate();

  const userName =
    user.id <= 0 ? 'Olá, Visitante' : `Olá, ${Capitalize(user.nome === '' ? user.nome_completo : user.nome)}`;

  const fantasia = dadosApp.Empresa.Empresa.fantasia_edicao
    ? dadosApp.Empresa.Empresa.fantasia_edicao
    : dadosApp.Empresa.Empresa.fantasia;

  const whats =
    'https://api.whatsapp.com/send?text=Oi&phone=55' +
    dadosApp.Empresa.Config.whatsapp_gerencia_ddd +
    dadosApp.Empresa.Config.whatsapp_gerencia_telefone;

  const showCardapioSelecao = () => {
    navigate('/loja/Cardapio');
  };

  const showHidePedidos = () => {
    setOpenPedidos(openPedidos == 'none' ? 'block' : 'none');
  };

  const handleShowMenu = () => {
    if (dadosApp.TipoApp === 'DELIVERY' || dadosApp.TipoApp === 'BALCAO') {
      setModalMenu(true);
    } else setModalOpcoes(true);
  };

  const hasSocialLinks =
    dadosApp.Empresa.Config.facebook?.trim() ||
    dadosApp.Empresa.Config.instagram?.trim() ||
    dadosApp.Empresa.Config.twitter?.trim() ||
    dadosApp.Empresa.Config.tiktok?.trim() ||
    dadosApp.Empresa.Config.youtube?.trim() ||
    (dadosApp.Empresa.Config.whatsapp_gerencia === 1 &&
      dadosApp.Empresa.Config.whatsapp_gerencia_ddd?.trim() &&
      dadosApp.Empresa.Config.whatsapp_gerencia_telefone?.trim());

  const handleTitleTop = () => {
    let _title = 'Nosso Cardápio';
    if (hasSocialLinks) {
      _title = 'Siga-nos:';
    }

    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {_title === 'Siga-nos:' ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginLeft: 15 }}>
            <span style={{ fontSize: 12 }}>{_title}</span>
            {dadosApp.Empresa.Config.facebook && (
              <a href={dadosApp.Empresa.Config.facebook} target="_blank" rel="noreferrer" title="Facebook">
                <img src={LogoFacebook} loading="eager" alt={'facebook'} width={'24px'} />
              </a>
            )}

            {dadosApp.Empresa.Config.instagram && (
              <a href={dadosApp.Empresa.Config.instagram} target="_blank" rel="noreferrer" title="Instagram">
                <img src={LogoInstagram} loading="eager" alt={'instagram'} width={'24px'} />
              </a>
            )}

            {dadosApp.Empresa.Config.twitter && (
              <a href={dadosApp.Empresa.Config.twitter} target="_blank" rel="noreferrer" title="Twitter">
                <img src={LogoTwitter} loading="eager" alt={'twitter'} width={'24px'} />
              </a>
            )}

            {dadosApp.Empresa.Config.youtube && (
              <a href={dadosApp.Empresa.Config.youtube} target="_blank" rel="noreferrer" title="Youtube">
                <img src={LogoYoutube} loading="eager" alt={'youtube'} width={'24px'} />
              </a>
            )}

            {dadosApp.Empresa.Config.tiktok && (
              <a href={dadosApp.Empresa.Config.tiktok} target="_blank" rel="noreferrer" title="TikTok">
                <img src={LogoTikTok} loading="eager" alt={'tiktok'} width={'24px'} />
              </a>
            )}

            {dadosApp.Empresa.Config.whatsapp_gerencia === 1 &&
              dadosApp.Empresa.Config.whatsapp_gerencia_ddd &&
              dadosApp.Empresa.Config.whatsapp_gerencia_telefone && (
                <a href={whats} target="_blank" rel="noreferrer" title="WhatsApp">
                  <img src={LogoWhats} loading="eager" alt={'whatsapp'} width={'24px'} />
                </a>
              )}
          </div>
        ) : (
          <span style={{ fontSize: 12, marginLeft: 15 }}>{_title}</span>
        )}
      </div>
    );
  };

  const handleTitle = () => {
    if (dadosApp.TipoApp === 'DELIVERY' || dadosApp.TipoApp === 'BALCAO') {
      if (fantasia)
        return <h4 style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{userName}</h4>;
      else return '';
    }
    if (dadosApp.TipoApp === 'MESA') return <h4>Mesa: {dadosApp.Mesa}</h4>;
  };

  const isCardapioDigital = dadosApp.Qs.cardapioDigital === 'true';
  const showMenuButton = fantasia && !isCardapioDigital;
  const showSearchButton = fantasia && !isCardapioDigital;
  const showCardapioBtn =
    fantasia && !isCardapioDigital && dadosApp.Empresa?.Mult?.length > 1 && dadosApp.TipoApp === 'DELIVERY';

  return (
    <>
      <div id="top" className="barTop" ref={topBarRef}>
        <div className="container barTop__inner">
          {/* Esquerda: botão menu */}
          {showMenuButton && (
            <div className="barTop__left">
              <button
                ref={menuBtnRef}
                type="button"
                id="btn-menu"
                // style={{ borderWidth: 1 }}
                className="btnIcons button_menu color-black search-btn-native"
                onClick={handleShowMenu}
              >
                <i className="material-icons icon-no-pointer" style={{ fontWeight: 500 }}>
                  menu
                </i>
              </button>
            </div>
          )}

          {/* Centro: título */}
          <div className="barTop__center" style={{ overflow: 'hidden', marginRight: 10 }}>
            {isCardapioDigital && handleTitleTop()}
            {!isCardapioDigital && handleTitle()}
          </div>

          {/* Direita: busca + cardápio */}
          <div className="barTop__right" style={{ gap: 10 }}>
            {showCardapioBtn && (
              <button
                type="button"
                id="btn-cardapio"
                className="btnIcons button_menu color-red search-btn-native"
                onClick={showCardapioSelecao}
              >
                <i className="material-icons icon-no-pointer" style={{ fontWeight: 500 }}>
                  restaurant_menu
                </i>
              </button>
            )}
            {showSearchButton && (
              <button
                type="button"
                id="btn-search"
                className="btnIcons button_menu color-red search-btn-native"
                onClick={() => setBuscaAberta(true)}
              >
                <i className="material-icons icon-no-pointer" style={{ fontWeight: 500 }}>
                  search
                </i>
              </button>
            )}
          </div>
        </div>
      </div>

      {modalMenu && (
        <Modal
          title={userName}
          isFooter={true}
          visibility={modalMenu ? 'block' : 'none'}
          param={dadosApp}
          page="MENU"
          btnOnClickClose={() => setModalMenu(false)}
        />
      )}
      {modalOpcoes && (
        <Modal
          title={'Mesa ' + dadosApp.Mesa}
          isFooter={false}
          visibility={modalOpcoes ? 'block' : 'none'}
          param={{
            origin: 'modal',
            closeModal: () => setModalOpcoes(false),
          }}
          page="OPCAO_AUTO_ATENDIMENTO"
          btnOnClickClose={() => setModalOpcoes(false)}
        />
      )}
      {openPedidos.includes('block') && (
        <Modal
          title="Pedidos"
          isFooter={false}
          visibility={openPedidos}
          page="PEDIDOS"
          param={openPedidos}
          btnOnClickClose={showHidePedidos}
        />
      )}
      <BuscaDropdown open={buscaAberta} onClose={() => setBuscaAberta(false)} anchorRef={topBarRef} />
    </>
  );
};

BarTop.propTypes = {
  title: P.string,
};
